import api from "./axiosInterceptor";

export const fetchAppIntegrationUrls = () =>
  api.get(`/apps/app-integrations/urls`);
